import React from 'react';
import classNames from 'classnames';

import {
  ECollectionBannerState,
  ICollectionSlot,
} from '@lootboy/lib/slices/cardCollections/types';
import { ICardTemplate } from '@lootboy/lib/types/cards';

import ButtonClean from '~/components/ButtonClean';
import Image from '~/components/Image';

import { ReactComponent as PlusIcon } from '~/assets/images/iconsLibrary/plus-circle.svg';

import styles from './CollectionGridSlot.module.scss';

interface ICollectionGridSlotProps {
  slot: ICollectionSlot;
  placement: { row: number; column: number };
  onClick: () => void;
  insertedCard?: { cardId: string | null; cardTemplate: ICardTemplate } | null;
  collectionState: ECollectionBannerState;
}

const CollectionGridSlots: React.FC<ICollectionGridSlotProps> = ({
  slot,
  placement,
  onClick,
  insertedCard,
  collectionState,
}) => (
  <ButtonClean
    className={classNames(
      styles.slot,
      slot.specialGroup ? styles.slotSpecial : styles.slotNormal,
      { [styles.populated]: Boolean(insertedCard) },
    )}
    style={{
      gridColumn: placement.column,
      gridRow: placement.row,
    }}
    onClick={onClick}
  >
    {insertedCard && !slot.specialGroup ? (
      <Image
        alt="Inserted card graphic"
        path={insertedCard.cardTemplate.image}
      />
    ) : (
      <>
        {collectionState !== ECollectionBannerState.EXPIRED &&
          collectionState !== ECollectionBannerState.COMPLETED && <PlusIcon />}
        {Boolean(slot.label) && (
          <p className={styles.slotLabel}>{slot.label}</p>
        )}
      </>
    )}
  </ButtonClean>
);

export default React.memo(CollectionGridSlots);
